'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _UA = require('./UA');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * @Author: jerryfwang
 * @Date: 2019-05-15 18:06:27
 * @Last Modified by: jerryfwang
 * @Last Modified time: 2020-09-23 12:07:57
 */
/* eslint-disable no-undef */
var appIDs = {
  qq: {
    ADR: 'com.tencent.mobileqq',
    iOS: 'mqq'
  },
  wechat: {
    ADR: 'com.tencent.mm',
    iOS: '<wechat></wechat>'
  },
  qzone: {
    ADR: 'com.qzone'
  },
  kuaibao: {
    ADR: 'com.tencent.reading',
    iOS: 'qnreading'
  }
};
function getOptions() {
  var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var app = {};
  if (!_lodash2.default.isEmpty(config)) {
    app = config;
  } else if (key) {
    app = appIDs[key];
  }
  var result = {};
  if (app) {
    console.debug('===========qIsInstallApk app', JSON.stringify(app));
    var ua = window.navigator.userAgent;
    var platform = (0, _UA.getPlatform)(ua);
    console.debug('===========qIsInstallApk platform', platform, ua);
    switch (platform) {
      case 'iOS':
        result.apkKey = app.iOS;
        break;
      case 'ADR':
        result.packagename = app.ADR;
        break;
      default:
        break;
    }
  }
  console.debug('===========qIsInstallApk getOpts', JSON.stringify(result));
  return result;
}
// isNew 是否区分拉新拉活
function qIsInstallApk() {
  var app = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  console.debug('===========qIsInstallApk1', app, config);
  var isInstallApk = _lodash2.default.get(window, 'browser.app.isInstallApk');
  if (typeof window === 'undefined' || !isInstallApk) {
    return new Promise(function (resolve) {
      resolve(false);
    });
  }
  return new Promise(function (res) {
    return isInstallApk(res, getOptions(app, config));
  });
}
exports.default = qIsInstallApk;